// extracted by mini-css-extract-plugin
module.exports = {"button":"AppButton_button_1vfvM","light":"AppButton_light_2_cfx","danger":"AppButton_danger_PBjhn"};